import { useAuthenticationStore } from "../stores/authentication"

export default () => {
  const auth = useAuthenticationStore()
  if (!auth.isStaffSupport) {
    return {
      success: false,
      path: "/error",
    }
  }
  return {
    success: true,
  }
}
